module.exports = __webpack_public_path__ + "img/images/innovation.jpg?15799bae";